
import { useParams } from 'react-router-dom';
import { UpdateRSVPFlow } from './components/UpdateRSVPFlow';

const UpdateRSVPPage = () => {
  const { eventId } = useParams();

  if (!eventId) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Invalid event ID</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <UpdateRSVPFlow eventId={eventId} />
    </div>
  );
};

export default UpdateRSVPPage;
